import React, { Component } from "react";
import { get, has } from "lodash"

import { withStepsState } from "../../../shared/containers/containerStepsState"

import FirstTitle from '../../../shared/items/static/firstTitle';
import RadioButton from '../../../shared/items/controls/radioButton';
import HelpNextStepButton from "./helpNextStepButton"
import StepContentWrapper from "./../stepContentWrapper"
import StepControl from "./../stepControl"
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "../../../shared/services/service.step"
import { helpData } from "./static.helpData"
import { steps } from "../../../shared/static.steps"
import locales from "./../../../content.json"
import "./../../../shared/services/service.step.scss"

class Help extends Component {
  constructor() {
    super();

    this.state = {
      isOpenHelp: false,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.help) && !this.state.isOpenHelp)
      this.setState({ isOpenHelp: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, data, onSetStepData } = this.props
    const { isOpenHelp } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.help,
      isOpen: isOpenHelp,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (isOpenHelp && !has(data, ["help"]))
      onSetStepData("help")

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      isOpenHelp: state,
    })
  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { isOpenHelp } = this.state
    const params = {
      className: "wrapperHelp",
      currentIndex: currentIndex,
      stepIndex: steps.help,
    }

    return isOpenHelp ?
      <div className={buildStepClassName({ params })}>

        <StepContentWrapper>
          <FirstTitle>{locales[window.userLang].help_ask}</FirstTitle>

          {
            Object.keys(helpData).map((key, index) => {
              return (
                <RadioButton
                  key={index}
                  isChecked={get(data, ["help", key], false)}
                  onClick={
                    !get(data, ["help", key], false)
                      ? onUpdateStepData.bind(this, "help", key, true)
                      : onUpdateStepData.bind(this, "help", key, false)
                  }
                  icon={helpData[key].icon}
                >
                  {helpData[key].title}
                </RadioButton>
              )
            })
          }
        </StepContentWrapper>

        <StepControl>
          <HelpNextStepButton>{locales[window.userLang].continue}</HelpNextStepButton>
        </StepControl>
      </div>
      : null
  }
}

export default withStepsState(Help);